import { getContext as u, setContext as l } from "svelte";
import { CoreNodeView as m, CorePluginView as y, CoreWidgetView as C } from "@prosemirror-adapter/core";
import { nanoid as g } from "nanoid";
import { writable as w } from "svelte/store";
import { Decoration as P } from "prosemirror-view";
const j = (r) => u(r), v = "[ProsemirrorAdapter]useNodeViewFactory", A = () => u(v);
class p extends m {
  constructor() {
    super(...arguments), this.key = g(), this._context = {
      contentRef: (t) => {
        t && t instanceof HTMLElement && this.contentDOM && t.firstChild !== this.contentDOM && t.appendChild(this.contentDOM);
      },
      view: this.view,
      getPos: this.getPos,
      setAttrs: this.setAttrs,
      node: w(this.node),
      selected: w(this.selected),
      decorations: w(this.decorations),
      innerDecorations: w(this.innerDecorations)
    }, this.context = new Map(Object.entries(this._context)), this.updateContext = () => {
      const t = {
        node: this.node,
        selected: this.selected,
        decorations: this.decorations,
        innerDecorations: this.innerDecorations
      };
      Object.entries(t).forEach(([o, e]) => {
        const n = o;
        this.context.get(n).set(e);
      });
    }, this.render = () => {
      const t = this.component;
      return new t({
        target: this.dom,
        context: this.context
      });
    };
  }
}
const S = (r, t) => (e) => (n, i, s, h, a) => {
  const c = new p({
    node: n,
    view: i,
    getPos: s,
    decorations: h,
    innerDecorations: a,
    options: {
      ...e,
      onUpdate() {
        var d;
        (d = e.onUpdate) == null || d.call(e), c.updateContext();
      },
      selectNode() {
        var d;
        (d = e.selectNode) == null || d.call(e), c.updateContext();
      },
      deselectNode() {
        var d;
        (d = e.deselectNode) == null || d.call(e), c.updateContext();
      },
      destroy() {
        var d;
        (d = e.destroy) == null || d.call(e), t(c);
      }
    }
  });
  return r(c), c;
}, k = (r) => u(r), x = "[ProsemirrorAdapter]usePluginViewFactory", K = () => u(x);
class N extends y {
  constructor() {
    super(...arguments), this.key = g(), this._context = {
      view: w(this.view),
      prevState: w(this.prevState)
    }, this.context = new Map(Object.entries(this._context)), this.updateContext = () => {
      const t = {
        view: this.view,
        prevState: this.prevState
      };
      Object.entries(t).forEach(([o, e]) => {
        const n = o;
        this.context.get(n).set(e);
      });
    }, this.render = () => {
      const t = this.component;
      return new t({
        target: this.root,
        context: this.context
      });
    };
  }
}
const b = (r, t) => (e) => (n) => {
  const i = new N({
    view: n,
    options: {
      ...e,
      update: (s, h) => {
        var a;
        (a = e.update) == null || a.call(e, s, h), i.updateContext();
      },
      destroy: () => {
        var s;
        (s = e.destroy) == null || s.call(e), t(i);
      }
    }
  });
  return r(i), i;
}, f = () => {
  const r = w({});
  return {
    portals: r,
    renderSvelteRenderer: (e) => {
      r.update((n) => ({
        ...n,
        [e.key]: e.render()
      }));
    },
    removeSvelteRenderer: (e) => {
      r.update((n) => {
        const { [e.key]: i, ...s } = n;
        return s;
      });
    }
  };
};
class F extends C {
  constructor() {
    super(...arguments), this.key = g(), this._context = {
      view: this.view,
      getPos: this.getPos,
      spec: this.spec
    }, this.context = new Map(Object.entries(this._context)), this.updateContext = () => {
      const t = {
        view: this.view,
        getPos: this.getPos,
        spec: this.spec
      };
      Object.entries(t).forEach(([o, e]) => {
        this.context.set(o, e);
      });
    }, this.render = () => {
      const t = this.component;
      return new t({
        target: this.dom,
        context: this.context
      });
    };
  }
}
const U = (r) => u(r), V = "[ProsemirrorAdapter]useWidgetViewFactory", E = () => u(V), O = (r, t) => (e) => (n, i = {}) => {
  const s = new F({
    pos: n,
    options: e
  }), h = {
    ...i,
    destroy: (a) => {
      var c;
      (c = i.destroy) == null || c.call(i, a), t(s);
    }
  };
  return s.spec = h, P.widget(n, (a, c) => (s.bind(a, c), s.updateContext(), r(s), s.dom), h);
}, H = () => {
  const {
    renderSvelteRenderer: r,
    removeSvelteRenderer: t
  } = f(), o = S(r, t), e = b(r, t), n = O(r, t);
  l(v, o), l(x, e), l(V, n);
};
export {
  p as SvelteNodeView,
  N as SveltePluginView,
  F as SvelteWidgetView,
  v as nodeViewFactoryKey,
  x as pluginViewFactoryKey,
  j as useNodeViewContext,
  A as useNodeViewFactory,
  k as usePluginViewContext,
  K as usePluginViewFactory,
  H as useProsemirrorAdapterProvider,
  U as useWidgetViewContext,
  E as useWidgetViewFactory,
  V as widgetViewFactoryKey
};
//# sourceMappingURL=index.es.js.map
